module.exports = __webpack_public_path__ + "img/survey-1.edeb7a48.png";